import palette from '../palette';

export default {
  underline: {
    '&::before': {
      borderColor: palette.input.borderColor,
    },
  },
};
